




































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { storePengkajianRestrain } from "@/store/modules/PengkajianRestrainStore";
import PengkajianRestrainSvc from "@/services/PengkajianRestrain";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import { getHumanDateTime } from "@/utility/DateUtils";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";

const MONITORING_KEYS = [
  "kemerahan_tangan", "kemerahan_kaki",
  "biru_tangan", "biru_kaki",
  "luka_tangan", "luka_kaki",
  "nadi_melemah_tangan", "nadi_melemah_kaki",
  "nadi_tidak_teraba_tangan", "nadi_tidak_teraba_kaki"
];

@Component({
  components: {
    CardModalTtd,
    DokterAutoComplete,
    PersonAutoComplete,
    MonitoringDetail: () => import("./MonitoringRestrainDetail.vue")
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPengkajianRestrain extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isCreating = false;
  isEditing = false;
  editingId: number | null = null;
  modalTtd = false;
  signRole = "";
  signItem: any = null;
  saving = false;
  formValid = false;
  menuTgl = false;
  menuJam = false;
  showIndikasiError = false;

  // Monitoring
  showMonitoringForm = false;
  editingMonitoring: any = null;
  monitoringParentId: number | null = null;
  savingMon = false;

  form: any = this.getEmptyForm();
  monForm: any = this.getEmptyMonForm();

  kesadaranOptions = ["Composmentis", "Apatis", "Somnolen", "Sopor", "Koma"];

  monitoringParams = [
    {
      label: "Perubahan Warna Kulit",
      items: [
        { key: "kemerahan_tangan", label: "Kemerahan Tangan" },
        { key: "kemerahan_kaki", label: "Kemerahan Kaki" },
        { key: "biru_tangan", label: "Biru Tangan" },
        { key: "biru_kaki", label: "Biru Kaki" }
      ]
    },
    {
      label: "Adanya Luka/Lecet",
      items: [
        { key: "luka_tangan", label: "Luka Tangan" },
        { key: "luka_kaki", label: "Luka Kaki" }
      ]
    },
    {
      label: "Perkembangan Nadi",
      items: [
        { key: "nadi_melemah_tangan", label: "Nadi Melemah Tangan" },
        { key: "nadi_melemah_kaki", label: "Nadi Melemah Kaki" },
        { key: "nadi_tidak_teraba_tangan", label: "Nadi Tidak Teraba Tangan" },
        { key: "nadi_tidak_teraba_kaki", label: "Nadi Tidak Teraba Kaki" }
      ]
    }
  ];

  mounted() {
    storePengkajianRestrain.getByRegister(this.register);
    if (!storePerawat.listPerawat.length) {
      storePerawat.actListPerawatall();
    }
  }

  get stateList() {
    return storePengkajianRestrain.list;
  }

  get stateLoading() {
    return storePengkajianRestrain.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get hasAbnormalFindings(): boolean {
    for (const key of MONITORING_KEYS) {
      for (const cell of this.monForm[key]) {
        if (cell.ka === 1 || cell.ki === 1) return true;
      }
    }
    return false;
  }

  getEmptyForm() {
    return {
      tgl_pengkajian: localISODate(),
      jam_pengkajian: new Date().toTimeString().substr(0, 5),
      kesadaran: null,
      nadi: null,
      laju_pernapasan: null,
      tekanan_darah_sistol: null,
      tekanan_darah_diastol: null,
      suhu: null,
      nyeri: false,
      nyeri_vas: 0,
      gangguan_sensoris: false,
      gangguan_sensoris_lokasi: "",
      gangguan_sensori_perifer: false,
      gangguan_sensori_perifer_lokasi: "",
      gangguan_periferis: false,
      gangguan_periferis_lokasi: "",
      gangguan_sirkulasi: false,
      gangguan_sirkulasi_lokasi: "",
      cedera_pra_restrain: false,
      cedera_pra_restrain_lokasi: "",
      cedera_pra_restrain_deskripsi: "",
      indikasi_perilaku_kekerasan: false,
      indikasi_gelisah: false,
      indikasi_agitasi: false,
      indikasi_gangguan_kesadaran: false,
      indikasi_risiko_jatuh: false,
      indikasi_risiko_jatuh_skor: null,
      indikasi_lainnya: false,
      indikasi_lainnya_text: "",
      perlu_restrain: true,
      jenis_restrain_fisik: false,
      jenis_restrain_fisik_tipe: "",
      jenis_restrain_fisik_lokasi: "",
      jenis_seklusi: false,
      jenis_lainnya: false,
      jenis_lainnya_text: "",
      dokter_id: null,
      dokter_obj: null,
      perawat_id: null,
      perawat_obj: null
    };
  }

  getEmptyMonForm() {
    const form: any = {
      jam: [""],
      tindakan: [{ no: 1, tindakan: "", nama_perawat: "" }]
    };
    for (const key of MONITORING_KEYS) {
      form[key] = Array.from({ length: 7 }, () => ({ ka: 0, ki: 0 }));
    }
    return form;
  }

  formatTgl(date) {
    return getHumanDateTime(date);
  }

  isFullySigned(item) {
    return item.signed_dokter && item.signed_perawat;
  }

  canEditItem(item) {
    if (this.readOnly) return false;
    return !item.signed_dokter && !item.signed_perawat;
  }

  canDelete(item) {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.signed_dokter, penandaTanganId: item.dokter_id },
        { ditandatangani: item.signed_perawat, penandaTanganId: item.perawat_id }
      ],
      this.stateuser.id
    );
  }

  canSignDokter(item) {
    if (this.readOnly) return false;
    return !item.signed_dokter && item.dokter_id == this.stateuser.id;
  }

  canSignPerawat(item) {
    if (this.readOnly) return false;
    return !item.signed_perawat && item.perawat_id == this.stateuser.id;
  }

  setDokter(dokter) {
    if (dokter) {
      this.form.dokter_id = dokter.id;
      this.form.dokter_obj = dokter;
    }
  }

  startCreate() {
    this.form = this.getEmptyForm();
    this.isCreating = true;
    this.isEditing = false;
    this.editingId = null;
    this.showIndikasiError = false;
  }

  startEdit(item) {
    this.form = {
      ...item,
      dokter_obj: item.dokter ? { id: item.dokter.id, nama: item.dokter_nama } : null,
      perawat_obj: item.perawat ? { id: item.perawat.id, nama: item.perawat_nama } : null
    };
    this.form.dokter_id = item.dokter_id;
    this.form.perawat_id = item.perawat_id;
    this.isEditing = true;
    this.isCreating = false;
    this.editingId = item.id;
    this.showIndikasiError = false;
  }

  cancelForm() {
    this.isCreating = false;
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  hasAtLeastOneIndikasi() {
    return this.form.indikasi_perilaku_kekerasan
      || this.form.indikasi_gelisah
      || this.form.indikasi_agitasi
      || this.form.indikasi_gangguan_kesadaran
      || this.form.indikasi_risiko_jatuh
      || this.form.indikasi_lainnya;
  }

  async simpan() {
    if (!this.hasAtLeastOneIndikasi()) {
      this.showIndikasiError = true;
      return;
    }
    this.showIndikasiError = false;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        tgl_pengkajian: this.form.tgl_pengkajian,
        jam_pengkajian: this.form.jam_pengkajian,
        kesadaran: this.form.kesadaran,
        nadi: this.form.nadi,
        laju_pernapasan: this.form.laju_pernapasan,
        tekanan_darah_sistol: this.form.tekanan_darah_sistol,
        tekanan_darah_diastol: this.form.tekanan_darah_diastol,
        suhu: this.form.suhu,
        nyeri: this.form.nyeri,
        nyeri_vas: this.form.nyeri ? this.form.nyeri_vas : null,
        gangguan_sensoris: this.form.gangguan_sensoris,
        gangguan_sensoris_lokasi: this.form.gangguan_sensoris ? this.form.gangguan_sensoris_lokasi : null,
        gangguan_sensori_perifer: this.form.gangguan_sensori_perifer,
        gangguan_sensori_perifer_lokasi: this.form.gangguan_sensori_perifer ? this.form.gangguan_sensori_perifer_lokasi : null,
        gangguan_periferis: this.form.gangguan_periferis,
        gangguan_periferis_lokasi: this.form.gangguan_periferis ? this.form.gangguan_periferis_lokasi : null,
        gangguan_sirkulasi: this.form.gangguan_sirkulasi,
        gangguan_sirkulasi_lokasi: this.form.gangguan_sirkulasi ? this.form.gangguan_sirkulasi_lokasi : null,
        cedera_pra_restrain: this.form.cedera_pra_restrain,
        cedera_pra_restrain_lokasi: this.form.cedera_pra_restrain ? this.form.cedera_pra_restrain_lokasi : null,
        cedera_pra_restrain_deskripsi: this.form.cedera_pra_restrain ? this.form.cedera_pra_restrain_deskripsi : null,
        indikasi_perilaku_kekerasan: this.form.indikasi_perilaku_kekerasan,
        indikasi_gelisah: this.form.indikasi_gelisah,
        indikasi_agitasi: this.form.indikasi_agitasi,
        indikasi_gangguan_kesadaran: this.form.indikasi_gangguan_kesadaran,
        indikasi_risiko_jatuh: this.form.indikasi_risiko_jatuh,
        indikasi_risiko_jatuh_skor: this.form.indikasi_risiko_jatuh ? this.form.indikasi_risiko_jatuh_skor : null,
        indikasi_lainnya: this.form.indikasi_lainnya,
        indikasi_lainnya_text: this.form.indikasi_lainnya ? this.form.indikasi_lainnya_text : null,
        perlu_restrain: this.form.perlu_restrain,
        jenis_restrain_fisik: this.form.perlu_restrain ? this.form.jenis_restrain_fisik : false,
        jenis_restrain_fisik_tipe: this.form.jenis_restrain_fisik ? this.form.jenis_restrain_fisik_tipe : null,
        jenis_restrain_fisik_lokasi: this.form.jenis_restrain_fisik ? this.form.jenis_restrain_fisik_lokasi : null,
        jenis_seklusi: this.form.perlu_restrain ? this.form.jenis_seklusi : false,
        jenis_lainnya: this.form.perlu_restrain ? this.form.jenis_lainnya : false,
        jenis_lainnya_text: this.form.jenis_lainnya ? this.form.jenis_lainnya_text : null,
        dokter_id: this.form.dokter_obj ? this.form.dokter_obj.id : this.form.dokter_id,
        perawat_id: this.form.perawat_obj ? this.form.perawat_obj.id : this.form.perawat_id
      };

      let resp;
      if (this.isEditing && this.editingId) {
        resp = await PengkajianRestrainSvc.update(this.editingId, payload);
      } else {
        resp = await PengkajianRestrainSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pengkajian Restrain berhasil disimpan");
        this.cancelForm();
        storePengkajianRestrain.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd(item, role: string) {
    this.signItem = item;
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFn = this.signRole === "dokter"
      ? PengkajianRestrainSvc.signDokter
      : PengkajianRestrainSvc.signPerawat;

    const resp = await signFn(this.signItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      const label = this.signRole === "dokter" ? "Dokter" : "Perawat";
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
      appModule.addMsgTtd("");
      storePengkajianRestrain.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf(item) {
    PengkajianRestrainSvc.print(item.id);
  }

  async remove(item) {
    const q = confirm("Anda yakin akan menghapus Pengkajian Restrain ini?");
    if (!q) return;

    try {
      const resp = await PengkajianRestrainSvc.destroy(item.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storePengkajianRestrain.getByRegister(this.register);
      }
    } catch {
      // handled by service
    }
  }

  // ========== MONITORING ==========

  startCreateMonitoring(item) {
    this.monitoringParentId = item.id;
    this.editingMonitoring = null;
    this.monForm = this.getEmptyMonForm();
    this.showMonitoringForm = true;
  }

  addTindakan() {
    this.monForm.tindakan.push({
      no: this.monForm.tindakan.length + 1,
      tindakan: "",
      nama_perawat: ""
    });
  }

  async simpanMonitoring() {
    this.savingMon = true;

    try {
      const jamCount = this.monForm.jam.filter(j => j).length;
      const dataMonitoring: any = { jam: this.monForm.jam.filter(j => j) };

      for (const key of MONITORING_KEYS) {
        dataMonitoring[key] = this.monForm[key].slice(0, jamCount);
      }

      const tindakan = this.hasAbnormalFindings
        ? this.monForm.tindakan.filter(t => t.tindakan).map((t, i) => ({
            no: i + 1,
            tindakan: t.tindakan,
            nama_perawat: t.nama_perawat
          }))
        : null;

      const payload = {
        data_monitoring: dataMonitoring,
        tindakan
      };

      let resp;
      if (this.editingMonitoring) {
        resp = await PengkajianRestrainSvc.updateMonitoring(this.editingMonitoring.id, payload);
      } else {
        resp = await PengkajianRestrainSvc.storeMonitoring(this.monitoringParentId, payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Monitoring berhasil disimpan");
        this.showMonitoringForm = false;
        storePengkajianRestrain.getByRegister(this.register);
      }
    } finally {
      this.savingMon = false;
    }
  }

  async deleteMonitoring(mon, item) {
    const q = confirm(`Hapus Sesi Monitoring ${mon.sesi}?`);
    if (!q) return;

    try {
      const resp = await PengkajianRestrainSvc.deleteMonitoring(mon.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storePengkajianRestrain.getByRegister(this.register);
      }
    } catch {
      // handled
    }
  }
}
